import './AboutStore.scss';

export default function AboutStore() {
    return <div className="aboutStore">
        
    </div>
}
